import request from '@/utils/request'

// 
export function appToken(data) {
  return request({
    url: '/api-ierp/ierp/api/getAppToken.do',
    method: 'post',
    data: data
  })
}
export function accessToken(data) {
  return request({
    url: "/api-ierp/ierp/api/login.do",
    method: "post",
    data: data,
  });
}